export enum CodeType {
  ZAREJESTROWANO_SPRAWE_NA_WNIOSEK = 100,
  ZAREJESTROWANO_SPRAWE_Z_URZEDU = 101,
  POJAWIL_SIE_WPIS_W_REJESTRZE = 102,
  ZBLIZA_SIE_TERMIN_WYGASNIECIA_SUBSKRYPCJI = 103,
  SUBSKRYPCJA_ZOSTALA_ZAKONCZONA = 104,
}

export interface Powiadomienie {
  id: string;
  module: string;
  moduleFullName: string;
  receiveDate: Date;
  registrationDate: Date;
  payload: string;
  krs: string;
  nazwaPodmiotu: string;
  templateName: string;
  type: string;
  typeCode: string;
  content: string;
  wasReceived: boolean;
  wasSeen: boolean;
  deleted: boolean;
  isConfirmationOfReceive: boolean;
  dsRowClassNames?: string;
}
